import moment from "moment-timezone";
import AppointmentTimeslot from "../../appointment-timeslot/AppointmentTimeslot";
import { useCallback } from "react";
import useCalendarAppointmentDrop from "../hooks/useCalendarAppointmentDrop";
import styles from "./CalendarDropZone.module.scss";
import getClasses from "utils/getClasses";
import { AmplitudePageName } from "utils/amplitude";

interface CalendarDropZoneProps {
  startValue: number;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  amplitudePageName: AmplitudePageName;
}

const CalendarDropZone = ({
  startValue,
  onClick,
  amplitudePageName,
}: CalendarDropZoneProps) => {
  const isInThePast = startValue < Date.now();

  const getRescheduledAppointment = useCallback(
    (appointment: AppointmentWithSeriesInfo & { invoice?: InvoiceData }) => {
      const durationMinutes = moment(appointment.appointment_end).diff(
        moment(appointment.appointment_start),
        "minutes",
      );

      const newAppointmentStart = moment(startValue);
      const newAppointmentEnd = moment(newAppointmentStart).add(
        durationMinutes,
        "minutes",
      );

      return {
        ...appointment,
        appointment_start: newAppointmentStart.toISOString(),
        appointment_end: newAppointmentEnd.toISOString(),
      };
    },
    [startValue],
  );

  const { drop, temporaryAppointment, dragOverItem } =
    useCalendarAppointmentDrop({
      getRescheduledAppointment,
    });

  return (
    <div
      ref={drop}
      className={getClasses(
        styles["calendar-drop-zone"],
        dragOverItem ? styles["calendar-drop-zone--ready-for-drop"] : "",
      )}
      onClick={onClick}
    >
      {temporaryAppointment ? (
        <div
          className={
            styles["calendar-drop-zone__temporary-appointment-wrapper"]
          }
        >
          <AppointmentTimeslot
            appointment={temporaryAppointment}
            isDndPreview
            isInvalidDndPreview={isInThePast}
            amplitudePageName={amplitudePageName}
          />
        </div>
      ) : null}
    </div>
  );
};

export default CalendarDropZone;
